export default __webpack_public_path__ + "static/media/Banner-register-tutor.f2c82627.png";